module.exports = __webpack_public_path__ + "static/img/静止.b853d3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/叉车/静止.png
// module id = 1DU6
// module chunks = 76